import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Basetao Sheet
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              The ultimate resource for discovering researched Basetao products, buying guides, shipping information, and expert tips.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-lg bg-background-300/60 flex items-center justify-center hover:bg-primary-100 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-external-link-line text-foreground-600"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                  Basetao Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  Visit Main Website
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Top Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Sheet. All rights reserved. This is an independent research platform and is not affiliated with Basetao.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap"
            >
              Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}